import Layout from "components/Layout";
import SendListTable from "./components/SendListTable";

function SendList() {
  return (
    <Layout title="발송 리스트">
      <SendListTable />
    </Layout>
  );
}

export default SendList;
